module.exports = __webpack_public_path__ + "img/img5.df2aaef1.jpg";